import React, { ReactNode } from 'react';
import { useScope } from '@/hooks/useScope';
import { useAuth } from '@/contexts/AuthContext';
import { ScopeCode } from '@/constants/scopeCodes';

interface ScopeGateProps {
  scope: ScopeCode | ScopeCode[];
  children?: ReactNode;
  fallback?: ReactNode;
}

const ScopeGate: React.FC<ScopeGateProps> = ({
  scope,
  children,
  fallback,
}) => {
  const hasScope = useScope(scope);
  const { isLoading } = useAuth();

  // While auth is hydrating, render nothing to avoid a flash of AccessDenied
  if (isLoading) {
    return null;
  }

  // If the user lacks the required scope, render the fallback
  if (!hasScope) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
};

export default ScopeGate;